<div ngCloak class="wvTextItem FlexRowNoWrap" [ngClass]="hasBackdrop ? 'wvCustomItemDark' : 'wvCustomItemLight'" *ngIf="!slideError">
    <div [attr.id]="'wvTextItem-' + moduleKey" class="wvTextItem" [ngClass]="'wvTextItem-' + moduleKey" style="font-size:0px"></div>
</div>

<div class="wvCustomItem wvSlideError d-flex" *ngIf="slideError">
    <div class="sadErrorBox">
        <div class="errorCharacter"></div>

        <div class="errorText d-inline-block">
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Uh_Oh">Uh Oh</div>
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Something_Went_Wrong">Something went wrong</div>
        </div>
    </div>
</div>
